export const getPoinSize = (count: number) => {
  if (count > 10) {
    return 'large';
  }

  if (count === 1) {
    return 'small';
  }

  return 'medium';
};

export default 'DUMMY';
